import { render, staticRenderFns } from "./horizontalMenu.vue?vue&type=template&id=5982026e"
import script from "./horizontalMenu.vue?vue&type=script&lang=js"
export * from "./horizontalMenu.vue?vue&type=script&lang=js"
import style0 from "./horizontalMenu.vue?vue&type=style&index=0&id=5982026e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports